import React from 'react';
import { Bitcoin } from 'lucide-react';

export const Header: React.FC = () => {
  return (
    <header className="text-center mb-8 md:mb-12 px-4">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-3 mb-4">
        <Bitcoin className="w-16 h-16 sm:w-12 sm:h-12 text-orange-500 animate-pulse stroke-2" />
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
          Do I Have Enough Bitcoin?
        </h1>
      </div>
      <p className="text-gray-600 text-base sm:text-lg max-w-xl mx-auto">
        Track how many bitcoins you need for your dreams
      </p>
    </header>
  );
};